import React from 'react'
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import {  Pagination , Card } from 'antd';
import './Enseignant.css'
import Page1 from './/page1';
const { Meta } = Card;
function Enseignant() {
  return (
    <>
    <Header />

      <div className='containerEnseignants'>
        <div className='bgEnseignants'>  </div>
        <div className='ligne'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-287px', marginBottom: '200px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'70px'}}className="container-fluid text-white text-center ">Enseignants</h1>
          <p ><Link className='linkEnseignants' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkEnseignants'
            to="/"> ISIMM </Link>  <span>{'>'}</span> <Link className='linkEnseignants'
            to="/">Enseignants</Link> </p></div>
      </div>


        <Page1/>
        <Pagination  className='Pagination' defaultCurrent={1} total={60} style={{marginTop:'5%' , marginLeft:'auto' , marginRight:'auto'}} />;


        <Footer />

    </>
  )
}

export default Enseignant;
